import React, { useEffect, useRef, useState } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../lib/utils";
import {
  Shield,
  ArrowRight,
  Zap,
  Clock,
  Globe,
  Users,
  Database,
  TrendingUp,
  Eye,
  BarChart3,
  Building2,
  UserCheck,
  FileCheck,
  CheckCircle,
  Smartphone,
  ShoppingCart,
  Store,
  Gamepad2,
  Heart,
  Building,
  Phone,
  Brain,
  Activity,
  Network,
  ShieldAlert,
  CreditCard,
  Calendar,
  Factory,
  ShieldPlus,

  Monitor,
  BadgeCheck,
  GraduationCap,
  Plane,
  Tag, 
  AlertTriangle, 
  ClipboardCheck
} from "lucide-react";


import "./landingpage.css"
import { useNavigate } from "react-router-dom";
import addIssuer from '../pages/DashBoard/addIssuer.module.css'
import Modal from "../Utils/Modal";
import Loader from "../components/Loader";
import { BUTTONS } from "../Utils/Strings";
import { SEND_ONBOARD_EMAIL_VERIFIER } from "../Utils/constant";
import { Delay, EMAIL_CHECK, NAME_CHECK, NAME_CHECK_WITH_NUMBER } from "../Utils/helper";
import API from "../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
// ========== UI COMPONENTS ==========
// Button Component
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
  "bg-blue-600 text-white hover:bg-blue-700",

destructive:
  "bg-red-600 text-white hover:bg-red-700",

outline:
  "border border-gray-300 text-gray-900 hover:bg-gray-100",

secondary:
  "bg-gray-200 text-gray-900 hover:bg-gray-300",

ghost:
  "hover:bg-gray-100 text-gray-900",

link:
  "text-blue-600 underline-offset-4 hover:underline",
        black:"bg-black text-white hover:bg-black/90",
        success:"bg-green-600 text-white hover:bg-green-700"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(`custom-button ${buttonVariants({ variant, size, className })}`)}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

// Card Components
export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("rounded-lg border bg-card text-card-foreground shadow-sm", className)}
    {...props}
  />
));
Card.displayName = "Card";

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
));
CardHeader.displayName = "CardHeader";

export const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("text-2xl font-semibold leading-none tracking-tight", className)}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

export const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
CardDescription.displayName = "CardDescription";

export const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
));
CardContent.displayName = "CardContent";

export const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
));
CardFooter.displayName = "CardFooter";

// Badge Component


export const Badge = ({ variant = "default", className = "", ...props }) => {
  return <div className={`badge badge-${variant} ${className}`} {...props} />;
};

// Tabs Components
export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground", className)}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

export const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 " +
      "border border-blue-500 text-blue-500 bg-white hover:bg-blue-50 focus-visible:ring-blue-400 " +
      "data-[state=active]:bg-blue-500 data-[state=active]:text-white data-[state=active]:shadow-lg",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn("mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className)}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

// ========== MAIN COMPONENTS ==========

// Header Component
export const Header = () => {
  const [signUp, setSignUpPopup]=useState(false)
  const navigate=useNavigate()

const AddSingleUsers = () => {
  const [userForm, setUserForm] = useState({
    issuer: "verifier", // fixed to verifier
    company_name: "",
    email: "",
    company_alias: "",
    category: "", // verifier type (optional)
  });

  const [loading, setLoading] = useState(false);
  const [userError, setUserError] = useState({});
  const [verifierType, setVerifierType] = useState("Select Verifier type");

  const handleAddUser = async (e) => {
    e.preventDefault();
    let isValid = true;
    let tempError = {};

    // 🔍 Validate company name
    if (!userForm.company_name || !NAME_CHECK_WITH_NUMBER(userForm.company_name)) {
      isValid = false;
      tempError.company_name = true;
    }

    // 🔍 Validate email
    if (!userForm.email || !EMAIL_CHECK(userForm.email)) {
      isValid = false;
      tempError.email = true;
    }

    // 🔍 Validate alias (optional)
    if (userForm.company_alias && !NAME_CHECK_WITH_NUMBER(userForm.company_alias)) {
      isValid = false;
      tempError.company_alias = true;
    }
    userForm.category="3"
    // 🔍 Validate verifier type (if required)
    // if (verifierType === "Select Verifier type") {
    //   isValid = false;
    //   tempError.category = true;
    // } else {
    //   userForm.category = verifierType;
    // }

    const emailAPI = SEND_ONBOARD_EMAIL_VERIFIER;
    if (!emailAPI) {
      isValid = false;
      tempError.api = true;
    }

    setUserError(tempError);
    if (!isValid) return;

    setLoading(true);
    try {
      const res = await API.post(emailAPI, userForm);
      setLoading(false);
      if (res.status === 200) {
        setSignUpPopup(false);
        cogoToast.success(`Link Sent to ${userForm.email}`);
      } else {
        setSignUpPopup(false)
        cogoToast.error("Verifier could not be added!");
      }
    } catch (err) {
      setLoading(false);
      cogoToast.error(err.response?.data?.message || "Something went wrong!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let tempForm = { ...userForm };
    let tempError = { ...userError };
    tempForm[name] = value;

    // ✅ Validation clearing
    if (name === "email" && EMAIL_CHECK(value)) delete tempError.email;
    if (name === "company_name" && NAME_CHECK_WITH_NUMBER(value)) delete tempError.company_name;
    if (name === "company_alias" && (value === "" || NAME_CHECK_WITH_NUMBER(value)))
      delete tempError.company_alias;

    setUserError(tempError);
    setUserForm(tempForm);
  };

  const handleDocumentChange = (e) => {
    setVerifierType(e);
    let tempError = { ...userError };
    delete tempError.category;
    setUserError(tempError);
  };

  return (
    <form onSubmit={handleAddUser}>
      <Loader isOpen={loading} />

      <div className={addIssuer.modalBody}>

        {/* Company Name */}
        <label className={addIssuer.required}>Company Name</label>
        <div className={addIssuer.emailInput}>
          <input
            name="company_name"
            className={addIssuer.input}
            placeholder="Company Name"
            value={userForm.company_name}
            onChange={handleChange}
          />
          {userError?.company_name && (
            <p style={{ color: "red" }}>Please Enter a Valid Company Name!</p>
          )}
        </div>

        {/* Alias */}
        <label>Company Alias (Optional)</label>
        <div className={addIssuer.emailInput}>
          <input
            name="company_alias"
            className={addIssuer.input}
            placeholder="Company Alias"
            value={userForm.company_alias}
            onChange={handleChange}
          />
          {userError?.company_alias && (
            <p style={{ color: "red" }}>Please Enter a Valid Company Alias!</p>
          )}
        </div>

        {/* Email */}
        <label className={addIssuer.required}>Verifier Email</label>
        <div className={addIssuer.emailInput}>
          <input
            name="email"
            className={addIssuer.input}
            placeholder="name@example.com"
            value={userForm.email}
            onChange={handleChange}
          />
          {userError?.email && (
            <p style={{ color: "red" }}>Please Enter a Valid Email!</p>
          )}
        </div>

        {/* Verifier Type Dropdown (optional) */}
        {/* 
        <label className={addIssuer.required}>Verifier Type</label>
        <CustomDropDown
          list={["General", "Visitor", "Employment"]}
          selectedOption={verifierType}
          onSelect={handleDocumentChange}
        />
        {userError?.category && (
          <p style={{ color: "red" }}>Please choose a Verifier Type!</p>
        )}
        */}

        {/* Buttons */}
        <div className={addIssuer.popBtn} style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
          <button onClick={() => setSignUpPopup(false)} type="button" className="secondaryBtn">
            {BUTTONS.CANCEL}
          </button>
          <button type="submit" disabled={loading} className="Modalbutton">
            {loading ? BUTTONS.ADDING : "Add User"}
          </button>
        </div>
      </div>
    </form>
  );
};

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center space-x-2">
          {/* <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg"> */}
            <img src="/Header_icon.svg" alt="Header_icon.svg"/>
          {/* </div> */}
          <img  loading="eager" alt="" src="/authnumber_1.svg" />
        </div>

        <nav className="hidden md:flex items-center space-x-8">
          <a href="#features" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Features
          </a>
          <a href="#how-it-works" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            How it Works
          </a>
          <a href="#pricing" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Pricing
          </a>
          <a href="#contact" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Contact
          </a>
        </nav>

        <div className="flex items-center space-x-4">
          <Button variant="black" size="sm" onClick={()=>navigate("/app/Onboarding")}>
            Sign Up
          </Button>
          <Button size="sm" className="shadow-elegant hover:shadow-stats transition-all duration-300" onClick={()=>navigate("/app/login")}>
            Get Started
          </Button>
        </div>
      </div>

      <Modal title="Add Verifier" isOpen={signUp} onClose={(e)=>setSignUpPopup(false)} blockOutsideClick={true} children={<AddSingleUsers blockOutsideClick={false} />} />
    </header>
  );
};

// Hero Component
export const Hero = () => {
  const navigate=useNavigate()
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-feature-gradient overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-hero-gradient rounded-full blur-3xl opacity-10"></div>

      <div className="container relative z-10 text-center py-20" style={{flexDirection:"column"}}>
        <div className="animate-fade-in">
          <Badge variant="default" className="mb-8 px-4 py-2 text-sm">
            <Zap className="w-4 h-4 mr-1" />
            Automated, Web-based and Secure
          </Badge>

          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="text-foreground">AI-Powered</span>
            <br />
            <span className="bg-hero-gradient bg-clip-text text-transparent">
              Unified Authentication
            </span>
            <br />
            <span className="text-foreground">For the Entire Identity Lifecycle</span>
          </h1>

          <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-10 leading-relaxed">
            Transform fragmented Identity data into usable insights. Take authentication decisions in milliseconds
            across onboarding, verification, and fraud prevention with our self-learning AI engine.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button size="lg" className="px-8 py-3" onClick={()=> {
    const section = document.getElementById("how-it-works");
    section?.scrollIntoView({ behavior: "smooth" });
  }}>
              How it Works
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 animate-scale-in">
          <div className="flex flex-col items-center space-y-2">
            <Shield className="w-12 h-12 text-primary mb-2" />
            <h3 className="font-semibold text-foreground">Secure & Compliant</h3>
          </div>
          <div className="flex flex-col items-center space-y-2">
            <Zap className="w-12 h-12 text-primary mb-2" />
            <h3 className="font-semibold text-foreground">Lightning Fast</h3>
          </div>
          <div className="flex flex-col items-center space-y-2">
            <Clock className="w-12 h-12 text-primary mb-2" />
            <h3 className="font-semibold text-foreground">Available 24/7</h3>
          </div>
          <div className="flex flex-col items-center space-y-2">
            <Globe className="w-12 h-12 text-primary mb-2" />
            <h3 className="font-semibold text-foreground">Trusted Globally</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

// Benefits Component
export const Benefits = () => {
  const benefits = [
    {
      icon: Users,
      title: "Enhanced Staff Productivity",
      description: "Streamline your verification processes and free up valuable time for your team to focus on core business activities.",
      features: [
        "Authentication just a click away",
        "Peace of mind at no added cost",
        "Available 24/7 worldwide",
        "Enterprise-grade security"
      ]
    },
    {
      icon: Database,
      title: "Secure Data Repository",
      description: "Store all verification records in a centralised, encrypted repository that ensures compliance, audit readiness, and long-term accessibility.",
      features:[
        "Centralised, encrypted record-keeping",


"Compliance-ready for audits anytime",
"Long-term accessibility with zero data loss"
      ]
    },
    {
      icon: Shield,
      title: "Authentic Data Direct from Source",
      description: "Access verified information directly from trusted sources and regulators, eliminating the risk of tampered or outdated data.",
      features:[
        "Verified information from official records",


"No risk of tampered or outdated inputs",


"Trusted sources ensure complete accuracy"
      ]
    },
    {
      icon: TrendingUp,
      title: "Operational Efficiency & Lower Costs",
      description: " Automate repetitive tasks and minimise manual errors, cutting operational overheads while delivering faster results and improved ROI.",
      features:[
        "Automate manual tasks to save time",


"Reduce human error and duplication",


"Lower operational overhead with faster results"
      ]
    },
    {
      icon: Eye,
      title: "Secure Real-time Tracking",
      description: " Monitor every verification in real time with enterprise-grade encryption, ensuring complete visibility, accountability, and peace of mind at every step.",
      features:[
        "End-to-end visibility across all checks",


"Instant alerts for exceptions or anomalies",


"Enterprise-grade encryption for every update"
      ]
    },
    {
      icon: BarChart3,
      title: "Comprehensive Analytics",
      description: "Gain actionable insights with detailed analytics dashboards that highlight trends, performance, and verification outcomes—helping you make data-driven decisions with ease.",
      features: [
        "Actionable insights at your fingertips",


"Spot patterns and trends instantly",


"Make data-driven decisions faster"

      ]
    }
  ];

  return (
    <section id="features" className="py-20 bg-background">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary/10 rounded-full text-primary font-medium mb-4">
            Key Benefits
          </div>
          <h2 className="text-4xl font-bold mb-6 text-foreground">Why Choose AuthNumber?</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            AuthNumber enables seamless management of verification requests for organisations with a centralised,
            automated platform that provides data-driven insights.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <Card key={index} className="group hover:shadow-stats transition-all duration-300 border-0 shadow-card">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl mb-2">{benefit.title}</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    {benefit.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  {benefit.features && (
                    <ul className="space-y-2 mb-4">
                      {benefit.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-center text-sm text-muted-foreground">
                          <div className="w-1.5 h-1.5 bg-primary rounded-full mr-3"></div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* <Button variant="ghost" size="sm" className="p-0 h-auto text-primary hover:text-primary/80">
                    Learn more
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </Button> */}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

// Process Component
export const Process = () => {
  const steps = [
    {
      number: "1",
      icon: Building2,
      title: "Company A",
      subtitle: "Data Contribution",
      description: "Organizations contribute employee verification data to AuthNumber's secure central repository."
    },
    {
      number: "2",
      icon: UserCheck,
      title: "Employee Movement",
      subtitle: "Job Transition",
      description: "When employees move between organizations, the verification process becomes seamless."
    },
    {
      number: "3",
      icon: FileCheck,
      title: "Verification Request",
      subtitle: "Background Check",
      description: "Company B or verifiers can instantly request authentication through our platform."
    },
    {
      number: "4",
      icon: CheckCircle,
      title: "Instant Results",
      subtitle: "Real-time Verification",
      description: "Verification reports are generated instantly with complete audit trails and security."
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-background">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary/10 rounded-full text-primary font-medium mb-4">
            Process Overview
          </div>
          <h2 className="text-4xl font-bold mb-6 text-foreground">How AuthNumber Works</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Our streamlined verification process connects organizations, employees, and verifiers in a secure, automated ecosystem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative" style={{display:"flex", alignItems:"center"}}>
                <div>
                {/* Connection line for desktop */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 left-full w-8 h-0.5 bg-gradient-to-r from-primary/50 to-primary/20 transform -translate-y-1/2 z-0"></div>
                )}

                <Card className="relative z-10 group hover:shadow-stats transition-all duration-300 border-0 shadow-card">
                  <CardHeader className="text-center">
                    <div className="w-16 h-16 bg-hero-gradient rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <Badge variant="secondary" className="mb-2 mx-auto w-fit">
                      {step.number}
                    </Badge>
                    <CardTitle className="text-lg">{step.title}</CardTitle>
                    <CardDescription className="font-semibold text-primary">
                      {step.subtitle}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground text-center leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
                </div>
                <div>

                {(index === 0 || index === 1 || index==2) && (
                <Button size="sm" className="  mt-4 shadow-elegant hover:shadow-stats transition-all duration-300 ml-2">
                  <ArrowRight className="w-5 h-5" />
                </Button>
                )}
                </div>
              </div>

            );
          })}
        </div>
      </div>
    </section>
  );
};

// Stats Component
export const Stats = () => {
  const stats = [
    {
      value: "140+",
      label: "Countries",
      description: "Authbridge is trusted over by 3,000 clients in 140 countries for their background check needs."
    },
    {
      value: "3,000+",
      label: "Clients",
      description: "Over 3,000 companies, both big and small, are growing their business with Authbridge."
    },
    {
      value: "1B+",
      label: "Proprietary Data Records",
      description: "Our database contains over 1 billion proprietary data records for conducting background checks."
    },
    {
      value: "15M+",
      label: "Monthly Verifications",
      description: "AuthBridge conducts an impressive volume of 15 million background check every month."
    }
  ];

  return (
    <section className="py-20 bg-stats-gradient">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 text-foreground">Scale Simplified</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Our protection secures millions of users and processes billions of transactions
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group hover:scale-105 transition-transform duration-300">
              <div className="bg-card/50 backdrop-blur-sm rounded-2xl p-8 shadow-card hover:shadow-stats transition-shadow">
                <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-lg font-semibold text-foreground mb-2">
                  {stat.label}
                </div>
                <div className="text-sm text-muted-foreground">
                  {stat.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Industries Component
export const Industries = () => {
  const navigate=useNavigate()
  const industries = [
    {
      number: "001",
      icon: Building2,
      title: "Banking & Financial Services",
      description: "Enabling financial institutions to balance risk mitigation, user experience, and regulatory compliance with ease"
    },
    {
      number: "002",
      icon: Factory,
      title: "Manufacturing",
      description: "Protecting fintech growth in high-stakes digital economy with advanced fraud detection"
    },
    {
      number: "003",
      icon: ShoppingCart,
      title: "E-Commerce & Retail",
      description: "Blocking fraud to drive eCommerce conversions while maintaining seamless user experience"
    },
    {
      number: "004",
      icon: Users,
      title: "Staffing and Recruitment",
      description: "Onboarding trusted sellers and buyers to reduce risk and strengthen marketplace trust"
    },
    {
      number: "005",
      icon: ShieldPlus,
      title: "Healthcare and Pharma",
      description: "Strengthening trust with fair and secure gaming experience through identity verification"
    },
    {
      number: "006",
      icon: Monitor,
      title: "IT/ITeS",
      description: "Enhancing trust and safety of online dating platforms with comprehensive profile verification"
    },
    {
      number: "007",
      icon: Gamepad2,
      title: "Online Gaming",
      description: "Scalable identity solutions for large enterprises with complex verification requirements"
    },
    {
      number: "008",
      icon: Phone,
      title: "Telecom",
      description: "Seamless mobile identity verification for app-based platforms and services"
    },
    {
      number: "008",
      icon: BadgeCheck,
      title: "Insurance",
      description: "Seamless mobile identity verification for app-based platforms and services"
    },
    {
      number: "008",
      icon: GraduationCap,
      title: "Education",
      description: "Seamless mobile identity verification for app-based platforms and services"
    },
    {
      number: "008",
      icon: Plane,
      title: "Travel and Hospitality",
      description: "Seamless mobile identity verification for app-based platforms and services"
    },
    {
      number: "008",
      icon: Tag,
      title: "FMCG/FMCD",
      description: "Seamless mobile identity verification for app-based platforms and services"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary/10 rounded-full text-primary font-medium mb-4">
            Industry Solutions
          </div>
          <h2 className="text-4xl font-bold mb-6 text-foreground">
            Adaptive Defense Built for High-Risk Industries
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            AuthNumber transforms fragmented, multi-signal identity data into actionable insights,
            powering precise decisions in real-time for faster, smarter fraud prevention
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => {
            const IconComponent = industry.icon;
            return (
              <Card key={index} className="group hover:shadow-stats transition-all duration-300 border-0 shadow-card">
                <CardHeader>
                  <div className="flex items-center justify-between mb-4">
                    {/* <Badge variant="outline" className="text-xs">
                      {industry.number}
                    </Badge> */}
                    <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                      <IconComponent className="w-5 h-5 text-primary" />
                    </div>
                  </div>
                  <CardTitle className="text-lg mb-2">{industry.title}</CardTitle>
                  {/* <CardDescription className="text-sm text-muted-foreground leading-relaxed">
                    {industry.description}
                  </CardDescription> */}
                </CardHeader>
                <CardContent>
                  {/* <Button variant="ghost" size="sm" className="p-0 h-auto text-primary hover:text-primary/80 group">
                    Learn more
                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                  </Button> */}
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* <div className="text-center mt-12">
          <Button size="lg" className="shadow-elegant hover:shadow-stats transition-all duration-300" onClick={()=>navigate("/contact-us")}>
            Schedule a Demo
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div> */}
      </div>
    </section>
  );
};

// Technology Component
export const Technology = () => {

  const navigate=useNavigate()
  const technologies = [
    {
      icon: Brain,
      title: "AI & Machine Learning",
      description: "Advanced neural networks for pattern recognition and anomaly detection",
      features: [
        "Real-time decision making",
        "Self-learning algorithms",
        "Predictive analytics"
      ]
    },
    {
      icon: Activity,
      title: "Behavioral Analysis",
      description: "Deep behavioral profiling and user journey analysis",
      features: [
        "Mouse movement tracking",
        "Typing patterns",
        "Navigation behavior"
      ]
    },
    {
      icon: Network,
      title: "Network Intelligence",
      description: "Comprehensive network and device fingerprinting technology",
      features: [
        "IP reputation analysis",
        "Device fingerprinting",
        "Geo-location validation"
      ]
    },
    {
      icon: Smartphone,
      title: "Device Insights",
      description: "Multi-layered device analysis and risk assessment",
      features: [
        "Hardware profiling",
        "OS fingerprinting",
        "App behavior analysis"
      ]
    },
    {
      icon: Shield,
      title: "Identity Verification",
      description: "Document verification and biometric authentication",
      features: [
        "Document OCR/NLP",
        "Liveness detection",
        "Facial recognition"
      ]
    },
    {
      icon: Zap,
      title: "Unified Decisioning Engine",
      description: "Processing 500+ signals in <50ms",
      features: [
        "Real-time processing",
        "Multi-signal analysis",
        "Instant decisions"
      ]
    }
  ];

  return (
    <section className="py-20 bg-feature-gradient">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary/10 rounded-full text-primary font-medium mb-4">
            Technology Stack
          </div>
          <h2 className="text-4xl font-bold mb-6 text-foreground">
            Multiple Signals, One Decisioning Engine
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Our unified platform processes hundreds of data points in milliseconds, combining multiple authentication
            signals into a single, intelligent decision engine
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {technologies.map((tech, index) => {
            const IconComponent = tech.icon;
            return (
              <Card key={index} className="group hover:shadow-stats transition-all duration-300 border-0 shadow-card">
                <CardHeader>
                  <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl mb-2">{tech.title}</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    {tech.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {tech.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-muted-foreground">
                        <div className="w-1.5 h-1.5 bg-primary rounded-full mr-3"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" className="shadow-elegant hover:shadow-stats transition-all duration-300" onClick={()=>navigate("/contact-us")}>
            Talk to an Expert
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};

// UseCases Component
export const UseCases = () => {
  const navigate=useNavigate()
  const useCases = [
    {
      id: "verification",
      label: "Verification",
      icon: UserCheck,
      title: "Identity & Business Verification",
      number: "001",
      description: "Confidently automate compliance at scale with self-learning system core that makes smart decisions in milliseconds.",
      features: [
        {
          title: "User Verification",
          description: "Real-time identity document verification"
        },
        {
          title: "Business Verification",
          description: "Corporate entity and ownership validation"
        },
        {
          title: "Onboarding",
          description: "Seamless customer onboarding flow"
        },
        {
          title: "KYC/AML",
          description: "Automated compliance verification"
        }
      ]
    },
    {
      id: "fraud-prevention",
      label: "Fraud Prevention",
      icon: ShieldAlert,
      title: "Advanced Fraud Detection",
      number: "002",
      description: "Prevent fraud with AI-powered risk assessment and real-time threat detection across all touchpoints.",
      features: [
        {
          title: "Risk Scoring",
          description: "Real-time risk assessment and scoring"
        },
        {
          title: "Behavioral Analysis",
          description: "Advanced user behavior pattern detection"
        },
        {
          title: "Device Fingerprinting",
          description: "Comprehensive device identification"
        },
        {
          title: "Network Intelligence",
          description: "IP and network-based risk analysis"
        }
      ]
    },
    {
      id: "transaction-monitoring",
      label: "Transaction Monitoring",
      icon: CreditCard,
      title: "Real-time Transaction Analysis",
      number: "003",
      description: "Monitor transactions in real-time with AI-powered anomaly detection and automated compliance reporting.",
      features: [
        {
          title: "Real-time Monitoring",
          description: "Instant transaction analysis and alerts"
        },
        {
          title: "Anomaly Detection",
          description: "AI-powered unusual pattern identification"
        },
        {
          title: "Compliance Reporting",
          description: "Automated regulatory reporting"
        },
        {
          title: "Risk Analytics",
          description: "Advanced transaction risk scoring"
        }
      ]
    },
    {
      id: "credit-lending",
      label: "Credit & Lending",
      icon: TrendingUp,
      title: "Smart Credit Decisions",
      number: "004",
      description: "Make informed lending decisions with comprehensive identity verification and credit risk assessment.",
      features: [
        {
          title: "Credit Scoring",
          description: "AI-enhanced credit risk evaluation"
        },
        {
          title: "Income Verification",
          description: "Automated income and employment validation"
        },
        {
          title: "Document Verification",
          description: "Instant document authenticity checks"
        },
        {
          title: "Fraud Prevention",
          description: "Advanced application fraud detection"
        }
      ]
    }
  ];

  return (
    <section className="py-20 bg-feature-gradient">
      <div className="container" style={{flexDirection:"column"}}>
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary/10 rounded-full text-primary font-medium mb-4">
            Use Cases
          </div>
          <h2 className="text-4xl font-bold mb-6 text-foreground">
            Seamless Risk Orchestration Across Every Touchpoint
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Combine device, behavior, identity, network, and transaction data into one platform for real-time risk decisions across every digital touchpoint
          </p>
        </div>

        <Tabs defaultValue="verification" className="w-full">
          <TabsList className="grid w-full grid-cols-2 lg:grid-cols-4 mb-8">
            {useCases.map((useCase) => {
              const IconComponent = useCase.icon;
              return (
                <TabsTrigger
                  key={useCase.id}
                  value={useCase.id}
                  className="flex items-center space-x-2 text-sm ml-2"
                >
                  <IconComponent className="w-4 h-4" />
                  <span className="sm:inline">{useCase.label}</span>
                </TabsTrigger>
              );
            })}
          </TabsList>

          {useCases.map((useCase) => {
            const IconComponent = useCase.icon;
            return (
              <TabsContent key={useCase.id} value={useCase.id}>
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                  <div>
                    <Badge variant="outline" className="mb-4">
                      /{useCase.number}
                    </Badge>
                    <h3 className="text-3xl font-bold mb-4 text-foreground">
                      {useCase.title}
                    </h3>
                    <p className="text-lg text-muted-foreground mb-8">
                      {useCase.description}
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      {useCase.features.map((feature, index) => (
                        <div key={index}>
                          <h4 className="font-semibold text-foreground mb-2">
                            {feature.title}
                          </h4>
                          <p className="text-sm text-muted-foreground">
                            {feature.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <Button variant="outline" className="group" onClick={()=>navigate("/privacy-policy")}>
                      View Use Cases
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </div>

                  <div className="bg-card rounded-2xl p-8 shadow-card">
                    <div className="aspect-square bg-stats-gradient rounded-xl flex items-center justify-center">
                      <IconComponent className="w-24 h-24 text-primary" />
                    </div>
                  </div>
                </div>
              </TabsContent>
            );
          })}
        </Tabs>
      </div>
    </section>
  );
};

export default  function LogoCarousel() {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scroll = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft += 1; // speed
        if (
          scrollRef.current.scrollLeft >=
          scrollRef.current.scrollWidth / 2
        ) {
          scrollRef.current.scrollLeft = 0; // loop
        }
      }
    };

    const interval = setInterval(scroll, 20); // control smoothness
    return () => clearInterval(interval);
  }, []);

  const toplogos = [
    { id: 31, name: 'Logo 33', src: '/Birlasoft.svg.png' },
    { id: 1, name: 'Logo 1', src: '/hp_partners_emp_01.png' },
    { id: 2, name: 'Logo 2', src: '/hp_partners_emp_02.png' },
    { id: 3, name: 'Logo 3', src: '/hp_partners_emp_03.png' },
    { id: 4, name: 'Logo 4', src: '/hp_partners_emp_04.png' },
    { id: 6, name: 'Logo 5', src: '/hp_partners_emp_06.png' },
    { id: 7, name: 'Logo 6', src: '/hp_partners_emp_07.png' },
    { id: 8, name: 'Logo 7', src: '/hp_partners_emp_08.png' },
    { id: 9, name: 'Logo 11', src: '/hp_partners_emp_11.png' },
    { id: 10, name: 'Logo 12', src: '/hp_partners_ver_01.png' },
    { id: 11, name: 'Logo 13', src: '/hp_partners_ver_02.png' },
    { id: 12, name: 'Logo 14', src: '/hp_partners_ver_03.png' },
    { id: 13, name: 'Logo 15', src: '/hp_partners_ver_06.png' },
    { id: 14, name: 'Logo 16', src: '/hp_partners_ver_07.png' },
    { id: 15, name: 'Logo 17', src: '/hp_partners_ver_08.png' },
    { id: 32, name: 'Logo 34', src: '/Evalueserve_logo.jpg' },
    { id: 33, name: 'Logo 35', src: '/Freecharge_Logo.svg.png' },
    { id: 37, name: 'Logo 39', src: '/Manipal_Hospitals_logo.png' },
    { id: 40, name: 'Logo 41', src: '/Maxlife_logo.png' },
    { id: 42, name: 'Logo 43', src: '/L2_software_Development_india_pvt_ltd.png' },
    { id: 44, name: 'Logo 45', src: '/NetAmbit.png' },
    { id: 46, name: 'Logo 47', src: '/OFB_tech_pvt_ltd.png' },

  ]
    const bottomLogos=[
      { id: 16, name: 'Logo 18', src: '/hp_partners_ver_09.png' },
    { id: 17, name: 'Logo 19', src: '/hp_partners_ver_10.png' },
    { id: 18, name: 'Logo 20', src: '/hp_partners_ver_11.png' },
    { id: 19, name: 'Logo 21', src: '/hp_partners_ver_13.png' },
    { id: 20, name: 'Logo 22', src: '/hp_partners_ver_14.png' },
    { id: 22, name: 'Logo 24', src: '/Walmart.png' },
    { id: 23, name: 'Logo 25', src: '/tesco-logo.svg' },
    { id: 24, name: 'Logo 26', src: '/uber.png' },
    { id: 25, name: 'Logo 27', src: '/probo-logo.svg' },
    { id: 26, name: 'Logo 28', src: '/coforge-new-logo.png' },
    { id: 27, name: 'Logo 29', src: '/airtel-payment-bank.png' },
    { id: 28, name: 'Logo 30', src: '/icici-logo.svg' },
    { id: 29, name: 'Logo 31', src: '/witzeal-logo.svg' },
    { id: 30, name: 'Logo 32', src: '/swiggy-logo.svg' },
    { id: 34, name: 'Logo 36', src: '/GBFA.png' },
    { id: 35, name: 'Logo 37', src: '/GreyOrange-Robotics.png' },
    { id: 36, name: 'Logo 38', src: '/KFintech.png' },
    { id: 38, name: 'Logo 40', src: '/Mindtree_Logo.jpg' },
    { id: 41, name: 'Logo 42', src: '/igt-solutions-logo.png' },
    { id: 43, name: 'Logo 44', src: '/MEDANTA_the_medicity_hospital.png' },
    { id: 45, name: 'Logo 46', src: '/NEX_WEB_LOGO_NEXVAL.png' },
    { id: 47, name: 'Logo 48', src: '/New-Paladion-Logo.jpg' }
    ]

  // Duplicate list for smooth infinite loop
  const loopListTop = [...toplogos, ...toplogos];
  const loopListBottom = [...bottomLogos, ...bottomLogos]

  return (
    <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 text-foreground">
            Our Partners
          </h2>
      <div className="logo-carousel p-2">
        <div className="logo-track">
          {loopListTop.map((logo) => (
            <div className="logo-slide">
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {loopListTop.map((logo) => (
            <div key={`dup-${logo.id}`} className="logo-slide">
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
        </div>
      </div>
      <div className="logo-carousel p-2">
        <div className="logo-track">
          {loopListBottom.map((logo) => (
            <div className="logo-slide">
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {loopListBottom.map((logo) => (
            <div key={`dup-${logo.id}`} className="logo-slide">
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function EmployeeVerificationSection() {
  const features = [
    {
      icon: CheckCircle,
      title: "Real-Time Verifications with fastest TAT",
      desc: "Reduces TAT of ex employee verification with automation and a single view of Ex-employee information",
    },
    {
      icon: AlertTriangle,
      title: "Minimize Risk of Verification Frauds",
      desc: "Minimal manual intervention for ex-employee verifications reduces chances of frauds with reference checks",
    },
    {
      icon: ClipboardCheck,
      title: "Hassle-free exit management Compliance",
      desc: "Get compliance excellence in exit management with Vulnerability assessments, SSL encryption, enhanced security",
    },
  ];

  return (
    <section className="bg-sky-50 rounded-3xl px-6 py-16 md:px-16">
      <div className="mx-auto text-center">
        <h2 className="text-4xl font-bold mb-6 text-foreground">
          Now Do Ex-Employee Verifications via a Web-based Platform
        </h2>

        <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
          Streamline your exit employee verification process with an intuitive,
          easy to use platform
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={idx}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition"
              >
                <div className="flex justify-center mb-4">
                  <Icon className="h-10 w-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 text-center">
                  {item.title}
                </h3>
                <p className="mt-3 text-lg text-gray-600 text-center">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// CTA Component
export const CTA = () => {
  const navigate=useNavigate();
  return (
    <section
  id="contact"
  className="py-20 bg-hero-gradient relative overflow-hidden"
>

  {/* Background decoration */}
  <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
  <div className="absolute top-1/4 left-1/4 w-72 md:w-96 h-72 md:h-96 bg-white/10 rounded-full blur-3xl"></div>
  <div className="absolute bottom-1/4 right-1/4 w-72 md:w-96 h-72 md:h-96 bg-white/5 rounded-full blur-3xl"></div>

  <div className="relative z-10 text-center px-4">
    <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white">
      Interested? Get in Touch
    </h2>

    <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
      Ready to transform your identity verification process? Let's discuss how
      AuthNumber can solve your specific challenges and scale with your
      business.
    </p>

    {/* Buttons */}
    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 mr-2 ml-2">
      <Button
        size="lg"
        variant="black"
        className="px-8 py-3"
        onClick={() => navigate("/contact-us")}
      >
        Schedule a Demo
      </Button>

      <Button
        size="lg"
        variant="black"
        className="px-8 py-3 border-white/20 text-white hover:bg-white/10"
        onClick={() => navigate("/contact-us")}
      >
        Contact Sales
        <ArrowRight className="w-5 h-5 ml-2" />
      </Button>
    </div>

    {/* Stats - FIXED RESPONSIVENESS */}
    {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-4xl mx-auto">
      <div className="text-center">
        <div className="text-3xl font-bold text-white mb-2">99.99%</div>
        <div className="text-white/80">Uptime Guarantee</div>
      </div>

      <div className="text-center">
        <div className="text-3xl font-bold text-white mb-2">24/7</div>
        <div className="text-white/80">Support Available</div>
      </div>

      <div className="text-center">
        <div className="text-3xl font-bold text-white mb-2">15M+</div>
        <div className="text-white/80">Monthly Verifications</div>
      </div>
    </div> */}

    {/* Footer text */}
    <div className="border-t border-white/20 w-full max-w-md mx-auto pt-6">
      <p className="text-white/60 text-sm">
        AuthNumber - Transforming Identity Verification with AI-Powered
        Intelligence
      </p>
    </div>
  </div>
</section>

  );
};